import * as yup from 'yup';

import { VatInputType } from 'modules/menu/components/VatCategories';
import {
  yupTestMonetaryDecimals,
  yupTestUpToDecimalPlaces,
} from 'modules/menu/items/components/ItemDetailsForm/validationSchema';

import { OptionType } from '../../types';

export type ValidationContext = {
  currency: Currency;
};

const multiChoiceSchema = yup.object({
  name: yup.string().trim().required(),
  price: yup.number().test(yupTestMonetaryDecimals).required(),
  vat: yup
    .object({
      type: yup.mixed<VatInputType>(),
      categoryCode: yup.string(),
      percentage: yup.number(),
    })
    .test('percentage', 'VAT must be between 0% and 99%', vat => {
      if (vat.percentage) {
        return vat.percentage >= 0 && vat.percentage <= 99 && yupTestUpToDecimalPlaces(2).test(vat.percentage);
      }
      return true;
    }),
  maximumSelections: yup.number().min(yup.ref('minimumSelections')),
  minimumSelections: yup.number().min(0).required(),
});

const singleChoiceSchema = yup.object({
  name: yup.string().trim().required(),
  price: yup.number().test(yupTestMonetaryDecimals).required(),
  vat: yup
    .object({
      type: yup.mixed<VatInputType>(),
      categoryCode: yup.string(),
      percentage: yup.number(),
    })
    .test('percentage', 'VAT must be between 0% and 99%', vat => {
      if (vat.percentage) {
        return vat.percentage >= 0 && vat.percentage <= 99 && yupTestUpToDecimalPlaces(2).test(vat.percentage);
      }
      return true;
    }),
});

const boolSchema = singleChoiceSchema;

export const validationSchema = yup
  .object({
    name: yup.string().trim().required(),
    defaultValueIndex: yup.string(),
    externalId: yup.string(),
    type: yup.mixed<OptionType>().oneOf(['bool', 'choice', 'multi_choice']),
    visibileToCourier: yup.boolean(),
    values: yup.mixed().when('type', (type: OptionType) => {
      if (type === 'multi_choice') {
        return yup.array().of(multiChoiceSchema);
      }
      if (type === 'choice') {
        return yup.array().of(singleChoiceSchema);
      }
      return yup.mixed().notRequired();
    }),
    boolValues: yup.mixed().when('type', (type: OptionType) => {
      if (type === 'bool') {
        return yup.array().of(boolSchema);
      }
      return yup.mixed().notRequired();
    }),
  })
  .required();

export type ValidFormValues = yup.Asserts<typeof validationSchema>;
